module.exports = require('./helpers/bundle-url').getBundleURL('hOC9M') + "logo-dark.eefe0b7f.svg";